export default "__VITE_ASSET__5df0837b__"